import { useParams } from "react-router";

import useClientRedirect from "~/hooks/useClientRedirect";

const RedirectPageRoute = ({ to }: { to: string }): null => {
  const params = useParams() as { [key: string]: string };
  const redirect = useClientRedirect();

  // Find any dynamic segments in the URL and replace them with the corresponding params
  Object.keys(params).forEach((key) => {
    to = to.replace(`:${key}`, params[key]);
  });

  redirect(to);

  return null;
};

export default RedirectPageRoute;
